var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-con',{attrs:{"main":_vm.vm.main,"sub":_vm.vm.sub}},[_c('div',{staticClass:"img-box"},[_c('img-swiper',{attrs:{"list":_vm.vm.list,"isNotAuto":_vm.isNotAuto,"isOnly":_vm.isOnly}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }